export function getCodeSnippets(lang){
    const php=`
    <?php
        $ch = curl_init('https://sandbox.sasapay.app/api/v1/auth/token/?grant_type=client_credentials');
        curl_setopt($ch, CURLOPT_HTTPHEADER, [
        'Authorization: Basic ' . base64_encode('YOUR_APP_CLIENT_ID:YOUR_APP_CLIENT_SECRET')
        ]);
        curl_setopt($ch, CURLOPT_SSL_VERIFYPEER, false);
        $response = curl_exec($ch);
        echo json_decode($response);
    `;
    const java=`
        public class Main {
        public static void main(String[] args) throws Exception {
            
            String accessToken = String.valueOf(getAccessToken());
    
            System.out.println("tokenjson " + accessToken);
            
        }
        
        public static JSONObject getAccessToken() throws Exception {
            String tokenUrl = "{{ENDPOINT}}";
            String clientId = "{{CLIENT_ID}}";
            String clientSecret = "{{CLIENT_SECRET}}";
    
            HttpURLConnection conn = (HttpURLConnection) new URL(tokenUrl).openConnection();
    
            String encoded = Base64.getEncoder().encodeToString((clientId + ":" + clientSecret).getBytes());
            conn.setRequestProperty("Authorization", "Basic " + encoded);
            conn.setRequestMethod("GET");
            conn.setDoOutput(true);
    
            if (conn.getResponseCode() != 200) {
                throw new Exception("Failed to get access token");
            }
    
            BufferedReader br = new BufferedReader(new InputStreamReader(conn.getInputStream()));
            StringBuilder response = new StringBuilder();
            String line;
            while ((line = br.readLine()) != null) {
                response.append(line);
            }
            br.close();
    
            JSONObject json = new JSONObject(response.toString());
            return json;
        }
    }
    `;
    
        const python=`import base64
    import requests, json
    
    client_id = "client_id"
    client_secret="client_secret"
    url = 'https://sandbox.sasapay.app/api/v1/auth/token/?grant_type=client_credentials'
    base64_string = base64.b64encode(f"{client_id}:{client_secret}".encode()).decode("ascii")
    headers = {
                'Authorization': f'Basic {base64_string}' 
                }
    payload = {}
    try:
        res = requests.get(url, headers=headers, data=payload)
        response = json.loads(res.text)
        return response
    except Exception as error:
        return False`;

    const javascript=`
    const unirest = require('unirest');
    const req = unirest('GET', 'https://sandbox.sasapay.app/api/v1/auth/token/?grant_type=client_credentials')
      .headers({
        'Authorization': 'Basic {BASE64_TOKEN}'
      })
      .end(function (res) { 
        if (res.error) throw new Error(res.error); 
        console.log(res.raw_body);
      });

    `;

    if (lang==='java') {
        return java;
    } else if (lang==='php') {
        return php
    }
    else if (lang==='python') {
        return python
    }
    else if (lang==='javascript') {
        return javascript
    }
    else{
        return `The code snippets for ${lang} is coming soon!`
    }
}
export function getAuthResponse(){
    return `
    {
        "status": true,
        "detail": "SUCCESS",
        "access_token": "KCeHr0WbFFqh0HFQvAEn5zabCLJteu",
        "expires_in": 3600,
        "token_type": "Bearer",
        "scope": "merchants C2B/B2B/B2C"
    }
    `
}